/* ==========================================================================
   CYBEART PRODUCT CARD  ·  rebuilt from scratch 2026-08-31
   Namespace: .pc — shares nothing with the previous implementation.

   Four independent jobs, each isolated so one failing cannot break another:
     1. ADD TO CART   — enhances the plain <a href="/cart/add?…"> into an AJAX
                        add. The link works with this file absent, blocked or
                        broken; the script only ever takes over when it is
                        certain it can finish the job.
     2. OPTIONS       — pills swap image, price, badge and the buy link.
     3. GLOW          — points the border light at the cursor.
     4. TILT          — 3D on the whole card, but it SNAPS FLAT the instant
                        the cursor reaches the buy bar (and on any press), so
                        the control is never moving when a click lands. That
                        distinction is what made Add to Cart reliable.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__cyProductCard) return;
  window.__cyProductCard = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var FINE = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var busy = false;

  function card(el) { return el.closest('.pc'); }

  /* ---------------------------------------------------------------- 1. CART */
  /* 2026-10-16 design system v3.2: the CTA's label is a text node (inside the .cys-roll wrapper once cybeart.js has wrapped
     it) next to the frame's SVG; writing textContent would wipe both, so only the text changes */
  function setLabel(cta, text) {
    var roll = cta.querySelector('.cys-roll');
    if (roll && roll.firstElementChild) {
      var s = roll.firstElementChild, copy = s.querySelector('.cys-roll__copy');
      if (s.firstChild && s.firstChild.nodeType === 3) s.firstChild.nodeValue = text; else s.insertBefore(document.createTextNode(text), s.firstChild);
      if (copy) copy.textContent = text;
      return;
    }
    var t = null; for (var i = 0; i < cta.childNodes.length; i++) { if (cta.childNodes[i].nodeType === 3 && cta.childNodes[i].textContent.trim()) { t = cta.childNodes[i]; break; } }
    if (t) t.nodeValue = text; else cta.insertBefore(document.createTextNode(text), cta.firstChild);
  }
  function addToCart(cta) {
    if (busy || cta.classList.contains('is-out')) return false;
    var id = cta.getAttribute('data-variant');
    if (!id || !window.fetch) return false;

    busy = true;
    var label = cta.getAttribute('data-label') || cta.textContent;
    cta.setAttribute('aria-busy', 'true');
    setLabel(cta, '…');

    var done = function (text, hold) {
      setLabel(cta, text);
      cta.removeAttribute('aria-busy');
      busy = false;
      setTimeout(function () { setLabel(cta, label); }, hold || 1600);
    };

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(cta.getAttribute('data-qty')) || 1 }] })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        done('✓ Added', 1800);
        afterAdd();
      })
      .catch(function () {
        /* the AJAX path failed — fall back to the real navigation, which is
           the link's own href and always works */
        window.location.href = cta.getAttribute('href');
      });
    return true;
  }

  /* What happens after a successful add is the THEME's decision, not this
     card's: it reads the same `settings.action_after_atc` the theme's own
     product forms use, published by snippets/js-variables.liquid as
     window.themeHDN.settings.actionAfterATC. So the card behaves exactly like
     add-to-cart everywhere else on the site, and changing the theme setting
     changes both at once.
       no                -> stay put (count + "✓ Added" are the confirmation)
       open_cart_drawer  -> open the drawer (theme default)
       go_cart_page      -> /cart
       go_checkout_page  -> /checkout
     Worth knowing: the theme opens that drawer with showModal(), and a modal
     <dialog> lays an inert backdrop over the WHOLE document, not just its own
     panel. So while the drawer is open every click on the grid goes to the
     backdrop — to add a second item you close the drawer first. That is the
     theme's behaviour, now matched deliberately; choose "no action" in Theme
     settings if you want several items added in a row without closing it. */
  function afterAdd() {
    var mode = 'open_cart_drawer';
    try {
      var t = window.themeHDN && window.themeHDN.settings && window.themeHDN.settings.actionAfterATC;
      if (t) mode = String(t);
    } catch (e) {}

    if (mode === 'go_cart_page') { window.location.href = ROOT + 'cart'; return; }
    if (mode === 'go_checkout_page') { window.location.href = ROOT + 'checkout'; return; }

    /* All four theme modes are honoured, including opening the drawer.
       It was briefly suppressed while the button itself was unreliable: the
       drawer is a modal <dialog>, so its backdrop covers the whole page, and
       that was masking whether a click had actually worked. Now that the
       button is a static target (only the photo tilts) the drawer is just
       normal behaviour — while it is open the grid behind it is intentionally
       inert, and closing it returns everything.
       To add several items without that interruption, set Theme settings →
       Cart → action after add to cart = "No action". */
    refreshCart(mode === 'open_cart_drawer');
  }

  /* Refresh the header count and the drawer's contents. Opens the drawer only
     when the theme setting asks for it. */
  function refreshCart(openDrawer) {
    /* 2026-10-05: the CY cart owns the refresh (one request, the "Added" strip) — assets/cy-cart.js */
    if (window.cyCart) { window.cyCart.refresh(openDrawer).catch(function () {}); return; }
    var drawer = document.querySelector('hdt-cart-drawer');
    var sid = (drawer && drawer.getAttribute('section-id')) || 'cart-drawer';
    fetch(ROOT + '?sections=' + sid)
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections[sid];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          if (drawer) {
            var fresh = doc.querySelector('cart-items-component');
            var cur = drawer.querySelector('cart-items-component');
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          }
          var ref = doc.querySelector('[ref="hdt-cart"]');
          if (ref) {
            var n = parseInt(ref.dataset.count || '0', 10);
            /* The theme's visible badge is the custom element <hdt-cart-count>,
               and the count itself lives as data-count on [ref="hdt-cart"] —
               NOT in a .cart-count span. Targeting the usual class names
               silently updated nothing, so the header still read the old
               number after a card add. Both are set here. */
            document.querySelectorAll('hdt-cart-count').forEach(function (el) { el.textContent = n; });
            document.querySelectorAll('[ref="hdt-cart"]').forEach(function (el) {
              el.setAttribute('data-count', n);
              if (ref.dataset.totalPrice) el.setAttribute('data-total-price', ref.dataset.totalPrice);
            });
            if (drawer) drawer.classList.toggle('is-empty', n === 0);
          }
        }
        /* let the theme update anything else that watches the cart */
        document.dispatchEvent(new CustomEvent('cart:reload'));
        if (openDrawer && drawer && typeof drawer.open === 'function') drawer.open();
      })
      .catch(function () { /* item is in the cart regardless */ });
  }

  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('[data-add]');
    if (!cta) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;  /* let new-tab work */
    if (addToCart(cta)) e.preventDefault();   /* only swallow if we took over */
  });

  /* The whole card opens the product (owner 2026-10-22: "Hand hover icon on full product card"; the card shows the hand everywhere, so every
     part of it must do something): a click that lands on no control of its own (photo, name, buy, option pills, any link or button) goes to the
     product's page, a Ctrl / Cmd / middle click opens it in a new tab. Controls keep their own action. */
  function openCard(e, newTab) {
    var c = e.target.closest && e.target.closest('.pc');
    if (!c || e.target.closest('a, button, input, select, label, [data-opt], [data-add]')) return;
    var link = c.querySelector('a.pc__media[href], .pc__title a[href]');
    if (!link) return;
    if (newTab) window.open(link.href, '_blank', 'noopener'); else window.location.href = link.href;
  }
  document.addEventListener('click', function (e) { if (e.button === 0) openCard(e, e.metaKey || e.ctrlKey); });
  document.addEventListener('auxclick', function (e) { if (e.button === 1) openCard(e, true); });

  /* There is deliberately no "click rescue" here any more.
     One used to exist because the card kept easing under the cursor and the
     browser then emitted no click. The tilt no longer eases (see TILT below),
     so a press and a release always land on the same element and the click is
     always produced. If anything ever did swallow it, the control is a real
     <a href="/cart/add?…"> and the browser simply follows it — the item still
     reaches the cart. Nothing here needs to guess. */

  /* ------------------------------------------------------------- 2. OPTIONS */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('[data-opt]');
    if (!pill) return;
    e.preventDefault();
    var c = card(pill);
    if (!c || pill.classList.contains('is-out')) return;

    c.querySelectorAll('[data-opt]').forEach(function (p) {
      var on = p === pill;
      p.classList.toggle('is-on', on);
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var img = c.querySelector('.pc__img--main');
    if (img && pill.dataset.img) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = pill.dataset.img;
    }
    /* the hover frame follows the chosen variant. Previously this hid the
       element outright, which killed the hover image for the rest of the
       visit once any option was picked. */
    var hov = c.querySelector('.pc__img--hover');
    if (hov) {
      if (pill.dataset.imgHover) {
        /* 2026-10-23: on touch screens a <source> gives the hover frame the main picture; a picked colourway has its own frame */
        if (hov.parentNode && hov.parentNode.tagName === 'PICTURE') hov.parentNode.querySelectorAll('source').forEach(function (s) { s.remove(); });
        hov.removeAttribute('srcset');
        hov.removeAttribute('sizes');
        hov.src = pill.dataset.imgHover;
        hov.hidden = false;
      } else {
        /* This colourway has no second shot. Must be [hidden] and not an
           inline display:none — the CSS guard reads
           :has(.pc__img--hover:not([hidden])) to decide whether to fade the
           main image out at all. With display:none the guard would still
           match, the main image would fade to nothing and the card would go
           blank on hover. */
        hov.hidden = true;
      }
    }

    var price = c.querySelector('.pc__price');
    if (price) {
      var now = price.querySelector('.pc__now');
      var was = price.querySelector('.pc__was');
      if (now && pill.dataset.now) now.textContent = pill.dataset.now;
      if (pill.dataset.was) {
        if (!was) {
          was = document.createElement('s');
          was.className = 'pc__was';
          price.insertBefore(was, price.firstChild);
        }
        was.textContent = pill.dataset.was;
        price.classList.add('is-sale');
      } else {
        if (was) was.remove();
        price.classList.remove('is-sale');
      }
    }

    var save = c.querySelector('.pc__badge--save');
    if (save) {
      if (pill.dataset.save) { save.textContent = 'Save ' + pill.dataset.save; save.hidden = false; }
      else { save.hidden = true; }
    }

    var cta = c.querySelector('[data-add]');
    if (cta && pill.dataset.variant) {
      cta.setAttribute('data-variant', pill.dataset.variant);
      var href = cta.getAttribute('href');
      if (href) cta.setAttribute('href', href.replace(/id=\d+/, 'id=' + pill.dataset.variant));
      var out = pill.dataset.avail === 'false';
      var pre = pill.dataset.pre === 'true';
      cta.classList.toggle('is-out', out);
      cta.classList.toggle('is-pre', !out && pre);
    }

    if (pill.dataset.url) {
      c.querySelectorAll('a[data-pr-url]').forEach(function (a) { a.href = pill.dataset.url; });
    }
  });

  /* ---------------------------------------------------- 3. GLOW  +  4. TILT */
  if (FINE) {
    var queued = false, active = null, mx = 0, my = 0, hold = false;
    /* Theme settings → Cybeart Custom → "Tilt strength", in degrees at the
       card edge. Falls back to 6 if the settings bridge is absent. */
    var TILT = Number((window.CY_SETTINGS || {}).cardTiltMax);
    if (!isFinite(TILT) || TILT <= 0) TILT = 6;

    function paint() {
      queued = false;
      if (!active) return;
      var r = active.getBoundingClientRect();
      if (!r.width) return;
      var dx = mx - (r.left + r.width / 2);
      var dy = my - (r.top + r.height / 2);
      /* glow: point the arc at the cursor */
      active.style.setProperty('--pc-glow', (Math.atan2(dy, dx) * 180 / Math.PI + 90) + 'deg');

      /* shadow: the cursor is the light, so the cast falls the other way.
         Normalised to the card's own half-width/height so a wide card and a
         tall one lean by the same amount. */
      var nx = Math.max(-1, Math.min(1, dx / (r.width / 2)));
      var ny = Math.max(-1, Math.min(1, dy / (r.height / 2)));

      active.style.setProperty('--pc-sx', (-nx * 14).toFixed(1) + 'px');
      active.style.setProperty('--pc-sy', (-ny * 10).toFixed(1) + 'px');

      /* THE PHOTO tilts, not the whole card.
         The buy bar, the title and the price are siblings of the stage, so
         they never move — the Add to cart button is a completely static
         target no matter where the cursor is.

         This is the fix for the last, subtlest failure: with the whole card
         tilting and the tilt following the cursor exactly, moving TOWARDS the
         button re-tilted the card and slid the button out from under the
         approaching cursor. The press then landed on whatever was beneath —
         the product link — and the shopper was taken to the product page
         instead of adding to the cart. Measured, not guessed: the click test
         reported url=/products/nighthawk-75-… after pressing on the button.

         Tilting only the stage removes the entire class of "the control moved"
         bugs by construction rather than by another guard: nothing the cursor
         can click is inside the moving element. */
      /* THE WHOLE CARD tilts.
         Except while the cursor is on (or just beside) the buy bar, where the
         transform is simply left ALONE — the card holds the angle it had when
         you arrived, so the button is a motionless target for the whole press.

         Two things make this safe, where the old freeze code was not:
         1. There is no transform transition, so "stop updating" means the card
            stops dead. The old version eased, so freezing still slid the
            button for another 350ms.
         2. `hold` is recomputed from the CURRENT pointer position on every
            move — it is not a flag anyone has to remember to reset. The old
            `frozen` flag could stick true forever and kill the tilt on every
            card; this cannot.
         The pad gives hysteresis: without it, a card that shifts by a pixel at
         the bar's edge would flip in and out of hold and jitter. */
      /* NO 3D TILT since 2026-10-05 (owner, product-card unlock for this only: "remove 3d tilt on hover from product
         cards"): the card never rotates or scales; the glow and the cast shadow above still follow the cursor. */
    }

    document.addEventListener('pointermove', function (e) {
      var c = e.target.closest && e.target.closest('.pc');
      if (!c) return;
      active = c; mx = e.clientX; my = e.clientY;

      /* Is the cursor on the buy bar (plus a small margin)? Derived from the
         live pointer position rather than from enter/leave events, because a
         boundary event can be missed entirely — the modal cart drawer opening
         over the page swallows them, which is how the previous flag-based
         version got stuck true and killed the tilt site-wide. */
      hold = false;
      var bar = c.querySelector('.pc__buy');
      if (bar) {
        var br = bar.getBoundingClientRect(), pad = 16;
        hold = e.clientX >= br.left - pad && e.clientX <= br.right + pad &&
               e.clientY >= br.top - pad && e.clientY <= br.bottom + pad;
        /* The cursor is close enough to click: end the entrance animation NOW
           and pin the button to its final position (see .is-settled in the
           stylesheet). This is what makes the bottom-to-top rise safe — the
           button can only ever be moving while the cursor is far from it.
           The 16px pad is hysteresis: the rise travels 14px, so without a pad
           wider than the movement, snapping could drop the button out from
           under a cursor sitting on its lower edge and flip the state back. */
        if (hold) c.classList.add('is-settled');
      }
      if (!queued) { queued = true; requestAnimationFrame(paint); }
    }, { passive: true });

    document.addEventListener('pointerleave', function (e) {
      /* the CARD's own leave, not a descendant's. Bound in the capture phase on
         document, so without this test every image and label inside the card
         reports a leave while the cursor is still on the card. */
      var c = e.target;
      if (!(c && c.classList && c.classList.contains('pc'))) return;
      /* the ONE place a transform transition is wanted: easing back to flat
         once the cursor has already left. It cannot affect a click — the
         pointer is no longer on the card. paint() clears it on re-entry. */
      /* 2026-10-22 (owner: "pull effect is not smooth when hover and out"): an inline transition replaces the card's own list, so it must carry
         the pull-up (translate) and the shadow too, or they snap back; and it is dropped once the ease is done, or every later visit lost them */
      c.style.transition = 'transform .35s var(--cy-ease-move), translate var(--cy-dur-move) var(--cy-ease-move), box-shadow var(--cy-dur-move) var(--cy-ease-move)';
      clearTimeout(c.__cyEase);
      c.__cyEase = setTimeout(function () { c.style.removeProperty('transition'); }, 400);
      c.style.transform = '';
      c.style.removeProperty('--pc-sx');
      c.style.removeProperty('--pc-sy');
      var stage = c.querySelector('.pc__stage');
      if (stage) stage.style.transform = '';   /* clear the photo-only tilt */
      /* re-arm the entrance rise for the next visit. If this leave is ever
         missed, the only cost is that the button appears without animating —
         a cosmetic loss, never a broken click. */
      c.classList.remove('is-settled');
      if (active === c) active = null;
      hold = false;
    }, true);
  }
})();

/* PILL ROW OVERFLOW (owner 2026-09-30: the card foot is one line) — when a card's variant pills cannot fit, the row
   scrolls sideways; this marks it .is-overflow so the CSS fades its right edge (a cut pill must look scrollable). */
(function () {
  'use strict';
  if (window.CyPillOverflow) return; window.CyPillOverflow = true;
  function mark() {
    document.querySelectorAll('.pc__foot .pc__opts').forEach(function (o) {
      var over = o.scrollWidth > o.clientWidth + 1;
      o.classList.toggle('is-overflow', over && o.scrollLeft + o.clientWidth < o.scrollWidth - 1);
    });
  }
  var t; function soon() { clearTimeout(t); t = setTimeout(mark, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
  window.addEventListener('resize', soon);
  document.addEventListener('scroll', function (e) { if (e.target.classList && e.target.classList.contains('pc__opts')) soon(); }, true);
  if ('MutationObserver' in window) new MutationObserver(soon).observe(document.body, { childList: true, subtree: true });
})();
